export default [
  {
    path: "/account",
    name: "Conta",
    component: () =>
      import(
        /* webpackChunkName: "account" */ "./pages/account/account.component.vue"
      ),
  },
];
